<template>
  <!-- eslint-disable -->
<svg class="feedpit-silo-crv crv-svg-icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14">
  <path d="M8.00222222,10.7692308 C9.60222222,9.33333333 11.6022222,8.61538462 14.0022222,8.61538462 C16.4022222,8.61538462 18.4022222,9.33333333 20.0022222,10.7692308 L20.0022222,14 L8.00222222,14 L8.00222222,10.7692308 Z M0,1.07692308 C0,0.358974359 1.16666667,0 3.5,0 C5.83333333,0 7,0.358974359 7,1.07692308 L7,14 L6,14 L6,10.7692308 L3.5,11.8461538 L1,10.7692308 L1,14 L0,14 L0,9.69230769 L0,1.07692308 Z" id="feedpitSiloCrv">
  </path>
</svg>
<!-- eslint-enable -->
</template>